import { z } from "zod/mini"

const EmbedConfigSchema = z.object({
	label: z.nullish(z.string()),
	placeholder: z.optional(z.string()),
	useAsTitle: z.optional(z.boolean()),
})

export const EmbedModelSchema = z.object({
	type: z.literal("Embed"),
	fieldset: z.nullish(z.string()),
	config: z.optional(EmbedConfigSchema),
})

export type EmbedModel = z.infer<typeof EmbedModelSchema>
